import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import schoolImage from "../../assets/images/school.jpg";
// import './School.css'
import AlertMessage from "../../AlertMessage";
import CreatePramanNode from "../Poshanaahar/CreatePramanNode";
import ThankYoupage from "./ThankYoupage";

const FREE_TRIAL_PLAN = {
  key: "freeTrial",
  firebaseKey: "freeTrial",
  nameEn: "Free Trial",
  nameMr: "फ्री ट्रायल",
  price: 0,
  mrp: 0,
  studentLimit: 20,
  durationDays: 7,
  badgeEn: "7 Days Free",
  badgeMr: "७ दिवस मोफत",
  badgeColor: "#6f42c1",
  isTrial: true,
  featuresEn: [
    "7 Days Full Access",
    "Up to 20 Students Limit",
    "Student Record & Registration",
    "Bonafide Certificate Generation",
    "Leaving Certificate (LC / TC)",
    "No Payment / Card Required"
  ],
  featuresMr: [
    "७ दिवस मोफत पूर्ण वापर",
    "कमाल २० विद्यार्थी मर्यादा",
    "विद्यार्थी नोंदणी व रेकॉर्ड",
    "बोनाफाइड प्रमाणपत्र जनरेशन",
    "शाळा सोडल्याचा दाखला (LC)",
    "कोणतेही शुल्क आवश्यक नाही"
  ],
  lockedModules: {
    admission: false,
    attandance: false,
    fee: false,
    exam: false,
    poshanahar: false,
    lc: false,
    idcard: false,
    bonafide: false
  }
};

const DEFAULT_PAID_PLANS = [
  {
    key: "plan100",
    firebaseKey: "100 Students",
    nameEn: "100 Students Plan",
    nameMr: "१०० विद्यार्थी प्लॅन",
    price: 5000,
    mrp: 5000,
    studentLimit: 100,
    durationDays: 365,
    badgeEn: "Starter",
    badgeMr: "स्टार्टर",
    badgeColor: "#6c757d",
    isTrial: false,
    featuresEn: [
      "Up to 100 Students Limit",
      "Student Record & Registration",
      "Bonafide Certificate Generation",
      "Leaving Certificate (LC / TC)",
      "Student Identity Cards",
      "Standard Reports & Export"
    ],
    featuresMr: [
      "कमाल १०० विद्यार्थी मर्यादा",
      "विद्यार्थी नोंदणी व रेकॉर्ड",
      "बोनाफाइड प्रमाणपत्र",
      "शाळा सोडल्याचा दाखला (LC)",
      "विद्यार्थी ओळखपत्र",
      "मानक अहवाल व निर्यात"
    ],
    lockedModules: {
      admission: false,
      attandance: false,
      fee: false,
      exam: false,
      poshanahar: false,
      lc: false,
      idcard: false,
      bonafide: false
    }
  },
  {
    key: "plan250",
    firebaseKey: "250 Students",
    nameEn: "250 Students Plan",
    nameMr: "२५० विद्यार्थी प्लॅन",
    price: 10000,
    mrp: 10000,
    studentLimit: 250,
    durationDays: 365,
    badgeEn: "Basic",
    badgeMr: "बेसिक",
    badgeColor: "#0dcaf0",
    isTrial: false,
    featuresEn: [
      "Up to 250 Students Limit",
      "Student Record & Registration",
      "Bonafide Certificate Generation",
      "Leaving Certificate (LC / TC)",
      "Student Identity Cards",
      "Standard Reports & Export"
    ],
    featuresMr: [
      "कमाल २५० विद्यार्थी मर्यादा",
      "विद्यार्थी नोंदणी व रेकॉर्ड",
      "बोनाफाइड प्रमाणपत्र",
      "शाळा सोडल्याचा दाखला (LC)",
      "विद्यार्थी ओळखपत्र",
      "मानक अहवाल व निर्यात"
    ],
    lockedModules: {
      admission: false,
      attandance: false,
      fee: false,
      exam: false,
      poshanahar: false,
      lc: false,
      idcard: false,
      bonafide: false
    }
  },
  {
    key: "plan500",
    firebaseKey: "500 Students",
    nameEn: "500 Students Plan",
    nameMr: "५०० विद्यार्थी प्लॅन",
    price: 15000,
    mrp: 15000,
    studentLimit: 500,
    durationDays: 365,
    badgeEn: "Popular",
    badgeMr: "लोकप्रिय",
    badgeColor: "#ffc107",
    isTrial: false,
    featuresEn: [
      "Up to 500 Students Limit",
      "All Basic Features",
      "Fee Management & Receipts",
      "Daily Student Attendance",
      "Staff & Teacher Attendance",
      "Fee Due SMS & Notifications"
    ],
    featuresMr: [
      "कमाल ५०० विद्यार्थी मर्यादा",
      "बेसिक प्लॅनच्या सर्व सुविधा",
      "फी व्यवस्थापन व पावती",
      "दैनिक विद्यार्थी उपस्थिती",
      "शिक्षक व कर्मचारी उपस्थिती",
      "फी थकबाकी माहिती व सूचना"
    ],
    lockedModules: {
      admission: false,
      attandance: false,
      fee: false,
      exam: false,
      poshanahar: false,
      lc: false,
      idcard: false,
      bonafide: false
    }
  },
  {
    key: "plan750",
    firebaseKey: "750 Students",
    nameEn: "750 Students Plan",
    nameMr: "७५० विद्यार्थी प्लॅन",
    price: 20000,
    mrp: 20000,
    studentLimit: 750,
    durationDays: 365,
    badgeEn: "Growth",
    badgeMr: "ग्रोथ",
    badgeColor: "#fd7e14",
    isTrial: false,
    featuresEn: [
      "Up to 750 Students Limit",
      "All 500 Plan Features",
      "Exam & Marksheet System",
      "Progress Report Card Generator",
      "Daily Attendance & SMS",
      "Standard & Custom Reports"
    ],
    featuresMr: [
      "कमाल ७५० विद्यार्थी मर्यादा",
      "५०० प्लॅनच्या सर्व सुविधा",
      "परीक्षा आणि निकाल प्रणाली",
      "प्रगती पुस्तक जनरेटर",
      "दैनिक उपस्थिती व SMS",
      "मानक व कस्टम अहवाल"
    ],
    lockedModules: {
      admission: false,
      attandance: false,
      fee: false,
      exam: false,
      poshanahar: false,
      lc: false,
      idcard: false,
      bonafide: false
    }
  },
  {
    key: "plan1000",
    firebaseKey: "1000 Students",
    nameEn: "1000 Students Plan",
    nameMr: "१००० विद्यार्थी प्लॅन",
    price: 25000,
    mrp: 25000,
    studentLimit: 1000,
    durationDays: 365,
    badgeEn: "Advanced",
    badgeMr: "प्रगत",
    badgeColor: "#0d6efd",
    isTrial: false,
    featuresEn: [
      "Up to 1000 Students Limit",
      "All 750 Plan Features",
      "Exam & Marksheet System",
      "Class Rank & Analytics",
      "Custom Report Templates",
      "Priority Technical Support"
    ],
    featuresMr: [
      "कमाल १००० विद्यार्थी मर्यादा",
      "७५० प्लॅनच्या सर्व सुविधा",
      "परीक्षा आणि निकाल प्रणाली",
      "गुणवत्ता व कामगिरी विश्लेषण",
      "कस्टम रिपोर्ट टेम्पलेट्स",
      "प्राधान्य तांत्रिक सपोर्ट"
    ],
    lockedModules: {
      admission: false,
      attandance: false,
      fee: false,
      exam: false,
      poshanahar: false,
      lc: false,
      idcard: false,
      bonafide: false
    }
  },
  {
    key: "plan1500",
    firebaseKey: "1500 Students",
    nameEn: "1500 Students Plan",
    nameMr: "१५०० विद्यार्थी प्लॅन",
    price: 35000,
    mrp: 35000,
    studentLimit: 1500,
    durationDays: 365,
    badgeEn: "Premium",
    badgeMr: "प्रीमियम",
    badgeColor: "#6f42c1",
    isTrial: false,
    featuresEn: [
      "Up to 1500 Students Limit",
      "All Advanced Features",
      "Poshanahar (Midday Meal) Reports",
      "Daily Meal Inventory & Stock",
      "Government Compliance Export",
      "Priority Dedicated Support"
    ],
    featuresMr: [
      "कमाल १५०० विद्यार्थी मर्यादा",
      "सर्व प्रगत सुविधा",
      "पोषण आहार दैनिक नोंद व अहवाल",
      "धान्य व आहार साठा ट्रॅकिंग",
      "शासकीय नियम पूर्ण करणारे रीपोर्ट",
      "प्राधान्य ग्राहक सेवा"
    ],
    lockedModules: {
      admission: false,
      attandance: false,
      fee: false,
      exam: false,
      poshanahar: false,
      lc: false,
      idcard: false,
      bonafide: false
    }
  },
  {
    key: "plan2000",
    firebaseKey: "2000 Students",
    nameEn: "2000 Students Plan",
    nameMr: "२००० विद्यार्थी प्लॅन",
    price: 45000,
    mrp: 45000,
    studentLimit: 2000,
    durationDays: 365,
    badgeEn: "Ultimate",
    badgeMr: "अल्टिमेट",
    badgeColor: "#198754",
    isTrial: false,
    featuresEn: [
      "Up to 2000 Students Limit",
      "Complete All-in-One School Suite",
      "Full Poshanahar (Midday Meal) System",
      "Custom Report Templates",
      "Government Compliance Export",
      "24/7 Dedicated Priority Support"
    ],
    featuresMr: [
      "कमाल २००० विद्यार्थी मर्यादा",
      "सर्वसमावेशक शाळा व्यवस्थापन",
      "संपूर्ण पोषण आहार प्रणाली",
      "कस्टम रिपोर्ट टेम्पलेट्स",
      "शासकीय नियम पूर्ण करणारे रीपोर्ट",
      "24/7 प्राधान्य ग्राहक सेवा"
    ],
    lockedModules: {
      admission: false,
      attandance: false,
      fee: false,
      exam: false,
      poshanahar: false,
      lc: false,
      idcard: false,
      bonafide: false
    }
  }
];

const INITIAL_PLANS = [FREE_TRIAL_PLAN, ...DEFAULT_PAID_PLANS];


const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

async function createRazorpayOrder(amountRupees, udise) {
  const endpoints = [
    "/backend/create_order.php",
    `${window.location.origin}/backend/create_order.php`,
    "http://localhost:8000/backend/create_order.php",
    "create_order.php"
  ];
  let lastError = null;
  for (const url of endpoints) {
    try {
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: amountRupees,
          receipt: `rcpt_${udise}_${Date.now()}`
        })
      });
      if (res.ok) {
        const data = await res.json();
        if (data && data.id) {
          return data;
        }
      }
    } catch (err) {
      lastError = err;
    }
  }
  throw lastError || new Error("Failed to reach create_order.php backend endpoint.");
}

function SchoolRegister() {
  const [step, setStep] = useState(1);
  const [plans, setPlans] = useState(INITIAL_PLANS);
  const [selectedPlanKey, setSelectedPlanKey] = useState("freeTrial");
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);

  const [schoolName, setSchoolName] = useState("");
  const [udiseNumber, setUdiseNumber] = useState("");
  const [password, setPassword] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [isPhoneNumberVerified, setIsPhoneNumberVerified] = useState(false);
  const [sentOtp, setSentOtp] = useState("");
  const [serverOtp, setServerOtp] = useState("");
  const [verificationStatus, setVerificationStatus] = useState("");
  const [showEnterOtp, setShowEnterOtp] = useState(false);
  const [isFormFilled, setIsFormFilled] = useState(false);
  const [invalidMobileNumber, setInvalidMobileNumber] = useState(false);
  const [language, setLanguage] = useState(localStorage.getItem("language"));
  const [showLanguageOverlay, setShowLanguageOverlay] = useState(!localStorage.getItem("language"));
  const [telephoneNumber, setTelephoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [taluka, setTaluka] = useState("");
  const [jilha, setJilha] = useState("");
  const [email, setEmail] = useState("");
  const [sansthaName, setsansthaName] = useState("");
  const [bridvakya, setbridvakya] = useState("");
  const [boardName, setBoardName] = useState("");
  const [indexNumber, setIndexNumber] = useState("");
  const [schoolCode, setSchoolCode] = useState("");
  const [sanlagnataKramank, setSanlagnataKramank] = useState("");
  const [manyataKramank, setManyataKramank] = useState("");
  const [madhyam, setMadhyam] = useState("");
  const [schoolLogo, setSchoolLogo] = useState("");
  const [schoolLogo2, setSchoolLogo2] = useState("");
  const [userStatus, setuserStatus] = useState("Deactive");
  const [price, setPrice] = useState("");
  const [salesConsultant, setsalesConsultant] = useState("");
  const [activationDate, setactivationDate] = useState("");
  const [boardType, setboardType] = useState("");

  const [showThankYoupage, setShowThankYoupage] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  // Fetch plans dynamically from Firebase Admin/purchesPlan node
  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const dbUrl = process.env.REACT_APP_FIREBASE_DATABASE_URL;
        if (!dbUrl) return;
        const res = await fetch(`${dbUrl}/Admin/purchesPlan.json`);
        if (!res.ok) return;
        const data = await res.json();
        if (data && typeof data === "object") {
          const mergedPaid = DEFAULT_PAID_PLANS.map((dp) => {
            const matchedKey = Object.keys(data).find((k) => {
              const fb = data[k];
              const cleanK = k.toLowerCase().replace(/[^a-z0-9]/g, "");
              const cleanDp = dp.key.toLowerCase().replace(/[^a-z0-9]/g, "");
              return (
                cleanK === cleanDp ||
                (fb && Number(fb.studentLimit) === dp.studentLimit) ||
                cleanK.includes(String(dp.studentLimit))
              );
            });
            if (matchedKey && data[matchedKey]) {
              const fb = data[matchedKey];
              const parsedPrice =
                fb.mrp && Number(fb.mrp) > 0
                  ? Number(fb.mrp)
                  : fb.fixRate && Number(fb.fixRate) > 0
                  ? Number(fb.fixRate)
                  : dp.price;
              const parsedLimit =
                fb.studentLimit && Number(fb.studentLimit) > 0
                  ? Number(fb.studentLimit)
                  : dp.studentLimit;
              return {
                ...dp,
                firebaseKey: matchedKey,
                price: isNaN(parsedPrice) ? dp.price : parsedPrice,
                mrp: fb.mrp || String(parsedPrice),
                fixRate: fb.fixRate || "",
                studentLimit: isNaN(parsedLimit) ? dp.studentLimit : parsedLimit,
              };
            }
            return dp;
          });

          setPlans([FREE_TRIAL_PLAN, ...mergedPaid]);
        }
      } catch (err) {
        console.warn("Failed to fetch Admin/purchesPlan from Firebase, using defaults:", err);
      }
    };

    fetchPlans();
  }, []);

  useEffect(() => {
    setIsFormFilled(!!schoolName && !!udiseNumber && !!password && !!mobileNumber);
  }, [schoolName, udiseNumber, password, mobileNumber]);

  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 4000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

  useEffect(() => {
    if (!language) {
      setShowLanguageOverlay(true);
    }
  }, [language]);

  useEffect(() => {
    if (language) {
      localStorage.setItem("language", language);
    }
  }, [language]);

  const handleLanguageChange = (e) => {
    const selectedLanguage = e.target.value;
    setLanguage(selectedLanguage);
    localStorage.setItem("language", selectedLanguage);
    setShowLanguageOverlay(false);
  };

  // ── Fresh OTP Send ──────────────────────────────────────────────────────────
  const sendMessage = async (e) => {
    e.preventDefault();

    const mobile = mobileNumber.trim();
    if (!mobile || mobile.length < 10) {
      setAlertMessage(
        language === "English"
          ? "Please enter a valid 10-digit mobile number."
          : "कृपया वैध १० अंकी मोबाइल नंबर प्रविष्ट करा."
      );
      return;
    }

    // Check if mobile already registered in Firebase
    try {
      const firebaseRes = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/user/${mobile}.json`
      );
      const firebaseData = firebaseRes.ok ? await firebaseRes.json() : null;

      if (firebaseData !== null) {
        const proceed = window.confirm(
          language === "English"
            ? "You have already registered with this number. Do you want to add another UDISE number with the same mobile number?"
            : "आपण या नंबरवर आधीच नोंदणी केली आहे. आपण याच मोबाइल नंबरसह दुसरा UDISE क्रमांक जोडू इच्छिता?"
        );
        if (!proceed) {
          setAlertMessage(
            language === "English"
              ? "Please use a different mobile number to register."
              : "नोंदणीसाठी कृपया वेगळा मोबाइल नंबर वापरा."
          );
          return;
        }
      }
    } catch (err) {
      // Firebase check failed — continue anyway so user isn't blocked
      console.warn("Firebase mobile check failed:", err);
    }

    // Generate & store OTP
    const otp = String(Math.floor(100000 + Math.random() * 900000));
    setSentOtp(otp);
    setShowEnterOtp(true);
    console.log("Generated OTP:", otp, "for mobile: +91" + mobile);

    setAlertMessage(
      language === "English"
        ? "Sending OTP to your mobile number..."
        : "आपल्या मोबाइलवर OTP पाठवत आहे..."
    );

    // Send OTP via PHP proxy (supports Hostinger live host & localhost)
    const smsEndpoints = [
      "/backend/send_sms.php",
      `${window.location.origin}/backend/send_sms.php`,
      "http://localhost:8000/backend/send_sms.php",
      "send_sms.php"
    ];

    let result = null;
    let lastErr = null;

    for (const url of smsEndpoints) {
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ mobile, otp }),
        });
        if (res.ok) {
          result = await res.json();
          break;
        }
      } catch (err) {
        lastErr = err;
      }
    }

    if (result) {
      console.log("SMS API Response:", result);
      if (result.success) {
        const isWhatsapp = result.whatsapp && result.whatsapp.status === "sent";
        setAlertMessage(
          language === "English"
            ? isWhatsapp
              ? "OTP sent to your mobile & WhatsApp."
              : "OTP sent successfully to your mobile number."
            : isWhatsapp
              ? "आपल्या मोबाइल आणि WhatsApp वर OTP पाठवला गेला आहे."
              : "OTP यशस्वीरित्या आपल्या मोबाइलवर पाठवला गेला."
        );
      } else {
        // Gateway returned error — still show OTP in alert for fallback
        console.error("SMS Gateway Error:", result.gateway_response);
        setAlertMessage(
          language === "English"
            ? `OTP: ${otp} (SMS Error: ${result.gateway_response || "check credentials"})`
            : `OTP: ${otp} (SMS त्रुटी: ${result.gateway_response || "credentials तपासा"})`
        );
      }
    } else {
      console.error("PHP Server Error:", lastErr);
      // Server unreachable — show OTP directly so user can still proceed
      setAlertMessage(
        language === "English"
          ? `SMS server offline. Your OTP: ${otp}`
          : `SMS सर्व्हर बंद आहे. आपला OTP: ${otp}`
      );
    }
  };
  // ────────────────────────────────────────────────────────────────────────────

  const [otpError, setOtpError] = useState("");

  const verifyOtp = (e) => {
    e.preventDefault();
    if (serverOtp.trim() === sentOtp.toString()) {
      setVerificationStatus(language === "English" ? "Your OTP Verified Successfully." : "आपला OTP यशस्वीरित्या सत्यापित झाला आहे.");
      setIsPhoneNumberVerified(true);
      setOtpError("");
    } else {
      setVerificationStatus("");
      setOtpError(language === "English" ? "OTP did not match." : "OTP जुळला नाही.");
    }
  };

  const handleChangeBoard = (e) => {
    setboardType(e.target.value);
  };

  const handleProceedToPlan = (e) => {
    e.preventDefault();
    if (!isPhoneNumberVerified) {
      setAlertMessage(language === "English" ? "Please verify your phone number first." : "कृपया आपला मोबाइल नंबर सत्यापित करा.");
      return;
    }
    if (serverOtp.trim() !== sentOtp.toString()) {
      setAlertMessage(language === "English" ? "Please verify your OTP." : "कृपया आपला OTP सत्यापित करा.");
      return;
    }

    // Check if UDISE number already exists in schoolRegister
    fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}.json`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data !== null) {
          setAlertMessage(language === "English" ? "You have already registered with this UDISE number. Please try forget password option with mobile number." : "आपण या UDISE क्रमांकद्वारे आधीच नोंदणी केली आहे. कृपया मोबाइल नंबरसह विसरलेला पासवर्ड पर्याय वापरा.");
          return;
        }
        setStep(2);
      })
      .catch((error) => {
        console.error("Error checking UDISE number:", error);
        setAlertMessage(language === "English" ? "Error validating UDISE number." : "UDISE नंबर तपासताना त्रुटी आली.");
      });
  };

  const finalizeRegistration = async (selectedPlan, paymentResponse) => {
    const isTrial = selectedPlan.isTrial || selectedPlan.price === 0 || selectedPlan.key === "freeTrial";
    const currentDate = new Date().toISOString().split("T")[0];

    // Deactivation Date: 7 days for Free Trial, 1 year for paid plans
    let formattedDeactivationDate;
    if (isTrial) {
      const deactivationDateObj = new Date();
      deactivationDateObj.setDate(deactivationDateObj.getDate() + (selectedPlan.durationDays || 7));
      formattedDeactivationDate = deactivationDateObj.toISOString().split("T")[0];
    } else {
      const deactivationDateObj = new Date();
      deactivationDateObj.setFullYear(deactivationDateObj.getFullYear() + 1);
      formattedDeactivationDate = deactivationDateObj.toISOString().split("T")[0];
    }

    const studentLimitStr = String(selectedPlan.studentLimit || (isTrial ? 20 : 500));
    const packActivatedKey = isTrial ? "freeTrial" : (selectedPlan.firebaseKey || selectedPlan.key);

    const schoolData = {
      schoolName,
      password,
      mobileNumber,
      language,
      telephoneNumber,
      address,
      taluka,
      jilha,
      email,
      sansthaName,
      bridvakya,
      boardName,
      boardType,
      indexNumber,
      schoolCode,
      sanlagnataKramank,
      manyataKramank,
      madhyam,
      schoolLogo,
      schoolLogo2,
      userStatus: "Active",
      salesConsultant,
      activationDate: currentDate,
      registerDate: currentDate,
      price: selectedPlan.price.toString(),
      udiseNumber: udiseNumber,
      packActivated: packActivatedKey,
      studentLimit: studentLimitStr
    };

    const userData = {
      mobileNumber,
      password,
      schoolName,
      udiseNumber,
      status: "DKglzhgYFYTDT141414HGCkkgfs22117785YFUTFybnujghhgtghghYFYVNOmC234567Omgkysfgvghyfjhyfvv56764",
    };

    const schoolRegisterData = {
      schoolData,
      studentData: {},
    };

    const adminData = {
      schoolName,
      mobileNumber,
      registerDate: currentDate,
      userStatus: "Active",
      activationDate: currentDate,
      deactivationDate: formattedDeactivationDate,
      packActivated: packActivatedKey,
      salePersonName: isTrial ? "OnlineFreeTrial" : "OnlineRegistration",
      finalPrize: selectedPlan.price.toString(),
      paidAmount: selectedPlan.price.toString(),
      studentLimit: studentLimitStr,
      paymentId: paymentResponse?.razorpay_payment_id || (isTrial ? "FREE_TRIAL" : ""),
      orderId: paymentResponse?.razorpay_order_id || (isTrial ? "FREE_TRIAL" : "")
    };

    const dbUrl = process.env.REACT_APP_FIREBASE_DATABASE_URL;

    // 1. Save Admin Node
    await fetch(`${dbUrl}/Admin/${udiseNumber}.json`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(adminData)
    });

    // 2. Save Locked Modules Node under Admin
    await fetch(`${dbUrl}/Admin/${udiseNumber}/lockedModules.json`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(selectedPlan.lockedModules)
    });

    // 3. Save User Node
    const userCheckRes = await fetch(`${dbUrl}/user/${mobileNumber}.json`);
    const existingUserData = await userCheckRes.json();

    if (existingUserData !== null) {
      const uniqueKey = new Date().getTime().toString();
      await fetch(`${dbUrl}/user/${mobileNumber}/${uniqueKey}.json`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(userData)
      });
    } else {
      await fetch(`${dbUrl}/user/${mobileNumber}.json`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(userData)
      });
    }

    // 4. Save schoolRegister Node
    await fetch(`${dbUrl}/schoolRegister/${udiseNumber}.json`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(schoolRegisterData)
    });

    // 5. Create Praman Node
    CreatePramanNode(udiseNumber, language);

    // 6. Show thank you screen
    setShowThankYoupage(true);
  };

  const handlePaymentAndRegistration = async () => {
    const selectedPlan = plans.find(p => p.key === selectedPlanKey) || plans[0];
    const isTrial = selectedPlan.isTrial || selectedPlan.price === 0 || selectedPlan.key === "freeTrial";

    // If Free Trial: bypass Razorpay and register directly!
    if (isTrial) {
      setIsProcessingPayment(true);
      try {
        await finalizeRegistration(selectedPlan, {
          razorpay_payment_id: "FREE_TRIAL",
          razorpay_order_id: "FREE_TRIAL"
        });
      } catch (err) {
        console.error("Error finalizing free trial registration:", err);
        setAlertMessage(language === "English" ? "Registration failed: " + err.message : "नोंदणी करताना त्रुटी आली: " + err.message);
      } finally {
        setIsProcessingPayment(false);
      }
      return;
    }

    // If Paid Plan: proceed with Razorpay
    setIsProcessingPayment(true);
    const isLoaded = await loadRazorpayScript();
    if (!isLoaded) {
      setAlertMessage(language === "English" ? "Razorpay SDK failed to load. Please check your internet connection." : "रेझरपे SDK लोड होण्यात अयशस्वी. कृपया तुमचे इंटरनेट कनेक्शन तपासा.");
      setIsProcessingPayment(false);
      return;
    }

    try {
      const orderData = await createRazorpayOrder(selectedPlan.price, udiseNumber);

      const options = {
        key: orderData.key_id || process.env.REACT_APP_RAZORPAY_KEY_ID || "rzp_live_TRgZXfPjk5xEuo",
        amount: orderData.amount,
        currency: orderData.currency || "INR",
        name: "E-Guruji Software",
        description: `${language === "English" ? selectedPlan.nameEn : selectedPlan.nameMr} - ${schoolName}`,
        order_id: orderData.id,
        prefill: {
          name: schoolName,
          contact: mobileNumber,
          email: email || ""
        },
        handler: async function (paymentResponse) {
          try {
            await finalizeRegistration(selectedPlan, paymentResponse);
          } catch (err) {
            console.error("Error finalizing registration:", err);
            setAlertMessage(language === "English" ? "Payment succeeded, but failed saving data: " + err.message : "पेमेंट मिळाले, परंतु डेटा जतन करताना त्रुटी आली.");
          } finally {
            setIsProcessingPayment(false);
          }
        },
        modal: {
          ondismiss: function () {
            setIsProcessingPayment(false);
            setAlertMessage(language === "English" ? "Payment process was cancelled." : "पेमेंट प्रक्रिया रद्द करण्यात आली.");
          }
        },
        theme: {
          color: "#007bff"
        }
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("Payment initiation error:", error);
      setAlertMessage(language === "English" ? "Failed to create payment order. " + error.message : "पेमेंट ऑर्डर तयार करण्यात अयशस्वी.");
      setIsProcessingPayment(false);
    }
  };

  return (
    <div className="p-3 p-md-5 mt-2">
      {showLanguageOverlay && (
        <div className="overlay" style={{ display: 'flex', width: '100%' }}>
          <div
            className="sidebar-template"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              maxHeight: '88vh',
              background: 'linear-gradient(135deg, #eaeff3, #3acad1)',
              padding: '15px 10px',
              borderRadius: '20px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.15)',
              animation: 'fadeIn 1s ease-in-out',
              marginTop: '35px',
            }}
          >
            <div
              className="card"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '20px',
                animation: 'slideIn 1s ease-in-out',
                background: '#fff',
                border: '1px solid #e0e0e0',
                borderRadius: '20px',
                boxShadow: '0 8px 20px rgba(0, 0, 0, 0.1)',
                marginTop: '40px',
                maxHeight: '85vh',
                overflowY: 'scroll',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none'
              }}
            >
              <div
                className="column english"
                style={{
                  flex: 1,
                  padding: '10px',
                  backgroundColor: '#ffffff',
                  borderRadius: '20px',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  animation: 'bounceIn 1.5s ease-in-out'
                }}
              >
                <h3
                  style={{
                    color: '#007bff',
                    marginBottom: '15px',
                    fontFamily: "'Poppins', sans-serif",
                    fontSize: '1.8em',
                    textAlign: 'center',
                    borderBottom: '2px solid  #ff7043',
                    paddingBottom: '10px'
                  }}
                >
                  <b>Smart Guruji Software</b>
                </h3>
                <p
                  style={{
                    fontSize: '14px',
                    lineHeight: '1.6',
                    fontFamily: "'Roboto', sans-serif",
                    color: '#333',
                    textAlign: 'center'
                  }}
                >
                  With this software, you can register your school, manage school information, and more. <br /><b>Please select your language to continue. You will be able to use the software in the selected language.</b>
                </p>
                <ol
                  style={{
                    paddingLeft: '20px',
                    marginTop: '20px',
                    fontFamily: "'Roboto', sans-serif",
                    color: '#007bff'
                  }}
                >
                  <li style={{ marginBottom: '10px' }}>Manage your school's information</li>
                  <li style={{ marginBottom: '10px' }}>Register students, fill in or update information</li>
                  <li style={{ marginBottom: '10px' }}>Bonafide</li>
                  <li style={{ marginBottom: '10px' }}>School leaving certificate</li>
                  <li style={{ marginBottom: '10px' }}>Student identification card</li>
                  <li style={{ marginBottom: '10px' }}>Various types of reports and much more</li>
                  <li style={{ marginBottom: '10px' }}>Available in Marathi and English Language</li>
                </ol>
              </div>
              <div
                className="column marathi"
                style={{
                  flex: 1,
                  padding: '25px 17px',
                  backgroundColor: '#ffffff',
                  borderRadius: '20px',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  animation: 'bounceIn 1.5s ease-in-out',
                  width: '98%',
                  marginTop: '-20px'
                }}
              >
                <h3
                  style={{
                    color: '#007bff',
                    marginBottom: '15px',
                    fontFamily: "'Poppins', sans-serif",
                    fontSize: '1.8em',
                    textAlign: 'center',
                    marginTop: '-15px',
                    borderBottom: '2px solid  #ff7043',
                    paddingBottom: '10px'
                  }}
                >
                  <b>स्मार्ट गुरुजी सॉफ्टवेअर</b>
                </h3>
                <p
                  style={{
                    fontSize: '14px',
                    lineHeight: '1.6',
                    fontFamily: "'Roboto', sans-serif",
                    color: '#333',
                    textAlign: 'center'
                  }}
                >
                  या सॉफ्टवेअरद्वारे आपण आपल्या शाळेची नोंदणी करू शकता, शाळेची माहिती व्यवस्थापित करू शकता आणि अधिक.<br /> <b>कृपया पुढे चालू ठेवण्यासाठी आपली भाषा निवडा. निवडलेल्या भाषेत तुम्हाला हे सॉफ्टवेअर वापरण्यास मिळेल.</b>
                </p>
                <ol
                  style={{
                    paddingLeft: '20px',
                    marginTop: '20px',
                    fontFamily: "'Roboto', sans-serif",
                    color: '#007bff',
                  }}
                >
                  <li style={{ marginBottom: '10px' }}>आपल्या शाळेची माहिती व्यवस्थापित करा</li>
                  <li style={{ marginBottom: '10px' }}>विद्यार्थी नोंदणी करा, माहिती भरा किंवा अपडेट करा.</li>
                  <li style={{ marginBottom: '10px' }}>बोनफाईड</li>
                  <li style={{ marginBottom: '10px' }}>शाळा सोडल्याचा दाखला</li>
                  <li style={{ marginBottom: '10px' }}>विद्यार्थी ओळख पत्र</li>
                  <li style={{ marginBottom: '10px' }}>विविध प्रकारचे रीपोर्ट आणि बरेच काही</li>
                  <li style={{ marginBottom: '10px' }}>मराठी आणि इंग्रजी भाषेत उपलब्ध</li>
                </ol>
              </div>
            </div>
          </div>
          <div
            className="center-content"
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '20px',
              marginLeft: 'auto'
            }}
          >
            <div
              className="language-box"
              style={{
                textAlign: 'center',
                backgroundColor: 'rgb(243, 238, 238)',
                width: '300px !important',
                padding: '40px 35px',
                borderRadius: '5px',
                boxShadow: '2px 0 5px rgba(0, 0, 0, 0.1)'
              }}
            >
              <h4 style={{ marginTop: '-30px' }}>Select Language</h4>
              <select
                className="form-select"
                style={{ width: '100%' }}
                value={language || ''}
                onChange={handleLanguageChange}
              >
                <option value="">Select Language</option>
                <option value="English">English</option>
                <option value="Marathi">मराठी</option>
              </select>
            </div>
          </div>
        </div>
      )}

      {showThankYoupage ? (
        <ThankYoupage />
      ) : (
        <div className={`col-12 mx-auto ${showLanguageOverlay ? 'blur-background' : ''}`}>
          <AlertMessage message={alertMessage} show={showAlert} />

          {step === 1 && (
            <div className="schoolRegisterForm col-md-8 col-lg-6 mx-auto mb-4 p-md-4">
              <h1 className="my-2 text-center fw-bold">
                {language === "English" ? "Register Your School" : "शाळा नोंदणी करा"}
              </h1>

              <div className="row my-3 sc-form align-items-center">
                <div className="col-md-5 col-sm-12 text-center mb-3 mb-md-0">
                  <img className="img-fluid rounded" src={schoolImage} alt="School" style={{ maxHeight: "280px", objectFit: "cover" }} />
                </div>

                <div className="col-md-7 col-sm-12">
                  <form className="h-100 text-start p-2">
                    <div className="mb-3">
                      <label htmlFor="schoolName" className="form-label fw-bold">
                        {language === "English" ? "School Name" : "शाळेचे नाव"}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={language === "English" ? "Enter school name" : "शाळेचे नाव प्रविष्ट करा"}
                        id="schoolName"
                        value={schoolName}
                        onChange={(e) => setSchoolName(e.target.value)}
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="udiseNumber" className="form-label fw-bold">
                        {language === "English" ? "UDISE Number" : "UDISE क्रमांक"}
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder={language === "English" ? "Enter UDISE number" : "UDISE क्रमांक प्रविष्ट करा"}
                        id="udiseNumber"
                        value={udiseNumber}
                        onChange={(e) => setUdiseNumber(e.target.value)}
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="boardType" className="form-label fw-bold">
                        {language === "English" ? "Board Type" : "बोर्ड प्रकार"}
                      </label>
                      <select className="form-select" id="boardType" value={boardType} onChange={handleChangeBoard}>
                        <option value="">{language === "English" ? "Select Board Type" : "बोर्ड प्रकार निवडा"}</option>
                        <option value="icse">ICSE</option>
                        <option value="cbse">CBSE</option>
                        <option value="stateBoard">State Board</option>
                      </select>
                    </div>

                    <div className="mb-3">
                      <label htmlFor="password" className="form-label fw-bold">
                        {language === "English" ? "Password" : "पासवर्ड"}
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder={language === "English" ? "Enter password" : "पासवर्ड प्रविष्ट करा"}
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="mobileNumber" className="form-label fw-bold">
                        {language === "English" ? "Mobile Number" : "मोबाइल क्रमांक"}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={language === "English" ? "Enter mobile number" : "मोबाइल क्रमांक प्रविष्ट करा"}
                        id="mobileNumber"
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        required
                      />
                      {invalidMobileNumber && (
                        <div className="text-danger small mt-1">
                          {language === "English" ? "Invalid mobile number" : "अवैध मोबाइल क्रमांक"}
                        </div>
                      )}
                    </div>

                    <div className="d-flex justify-content-between mb-3">
                      {!isPhoneNumberVerified ? (
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm"
                          onClick={sendMessage}
                          disabled={!mobileNumber.trim()}
                        >
                          {language === "English" ? "Send OTP" : "OTP पाठवा"}
                        </button>
                      ) : (
                        <span className="badge bg-success p-2">
                          ✓ {language === "English" ? "Phone number verified" : "मोबाइल क्रमांक सत्यापित झाला"}
                        </span>
                      )}
                    </div>

                    {showEnterOtp && (
                      <div className="p-3 bg-light rounded mb-3 border">
                        <label htmlFor="serverOtp" className="form-label fw-bold">
                          {language === "English" ? "Enter OTP" : "OTP प्रविष्ट करा"}
                        </label>
                        <input
                          type="text"
                          className="form-control mb-2"
                          placeholder={language === "English" ? "Enter OTP" : "OTP प्रविष्ट करा"}
                          id="serverOtp"
                          value={serverOtp}
                          onChange={(e) => setServerOtp(e.target.value)}
                        />
                        <button
                          type="button"
                          className="btn btn-primary btn-sm w-100"
                          onClick={verifyOtp}
                        >
                          {language === "English" ? "Verify OTP" : "OTP सत्यापित करा"}
                        </button>

                        {verificationStatus && (
                          <div className="mt-2 text-success small fw-bold">
                            {verificationStatus}
                          </div>
                        )}
                        {otpError && (
                          <div className="mt-2 text-danger small fw-bold">
                            {otpError}
                          </div>
                        )}
                      </div>
                    )}

                    <button
                      type="button"
                      className="btn btn-primary w-100 mt-3 py-2 fw-bold"
                      onClick={handleProceedToPlan}
                      disabled={!isFormFilled || !isPhoneNumberVerified}
                    >
                      {language === "English" ? "Proceed to Select Plan →" : "प्लॅन निवडा कडे जा →"}
                    </button>

                    <div className="text-center mt-3">
                      <span className="text-muted small">
                        {language === "English" ? "Already Registered?" : "आधीच नोंदणी केली आहे?"}
                      </span>
                      <Link className="text-decoration-none ms-1 fw-bold" to="/">
                        {language === "English" ? "Just Login" : "लॉगिन करा"}
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}

          {step === 2 && (
            <div className="col-12 col-xl-11 mx-auto my-3">
              <div className="text-center mb-4">
                <span className="badge bg-primary px-3 py-2 fs-6 mb-2">Step 2 of 2</span>
                <h2 className="fw-bold text-dark">
                  {language === "English" ? "Select Subscription Plan for Your School" : "आपल्या शाळेसाठी सबस्क्रिप्शन प्लॅन निवडा"}
                </h2>
                <p className="text-muted">
                  {language === "English"
                    ? `School: ${schoolName} (UDISE: ${udiseNumber})`
                    : `शाळा: ${schoolName} (UDISE: ${udiseNumber})`}
                </p>
              </div>

              <div className="row g-3 justify-content-center">
                {plans.map((plan) => {
                  const isSelected = selectedPlanKey === plan.key;
                  const isTrial = plan.isTrial === true || plan.key === "freeTrial";
                  return (
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex align-items-stretch" key={plan.key} style={{ minWidth: "220px", maxWidth: "300px" }}>
                      <div
                        className={`card h-100 w-100 shadow-sm border-2 rounded-4 ${
                          isSelected ? "border-primary bg-white shadow-lg ring-2" : "border-light bg-light"
                        }`}
                        style={{
                          cursor: "pointer",
                          transform: isSelected ? "scale(1.03)" : "scale(1)",
                          transition: "all 0.25s ease-in-out",
                        }}
                        onClick={() => setSelectedPlanKey(plan.key)}
                      >
                        <div className="card-header bg-transparent border-0 text-center pt-3 pb-1">
                          <span
                            className="badge rounded-pill text-uppercase px-3 py-1 mb-2 text-white fw-bold"
                            style={{ backgroundColor: plan.badgeColor || "#007bff" }}
                          >
                            {language === "English" ? plan.badgeEn : plan.badgeMr}
                          </span>
                          <h5 className="fw-bold my-1 text-dark">
                            {language === "English" ? plan.nameEn : plan.nameMr}
                          </h5>

                          {/* Student Limit Badge */}
                          <div className="my-2">
                            <span className="badge bg-primary-subtle text-primary border border-primary-subtle px-2 py-1 fw-bold fs-7">
                              👥 {plan.studentLimit} {language === "English" ? "Students" : "विद्यार्थी"}
                            </span>
                          </div>

                          {/* Price Display */}
                          <div className="my-1">
                            <span className="fs-3 fw-bold text-primary">
                              ₹{plan.price.toLocaleString("en-IN")}
                            </span>
                            <span className="text-muted small">
                              {" "}
                              / {isTrial
                                ? (language === "English" ? "7 days" : "७ दिवस")
                                : (language === "English" ? "year" : "वर्ष")}
                            </span>
                          </div>
                        </div>

                        <div className="card-body d-flex flex-column px-3 pt-2">
                          <ul className="list-unstyled mb-3 flex-grow-1">
                            {(language === "English" ? plan.featuresEn : plan.featuresMr).map((feat, idx) => (
                              <li key={idx} className="py-1 border-bottom border-light text-secondary small d-flex align-items-start">
                                <span className="text-success fw-bold me-2">✓</span>
                                <span>{feat}</span>
                              </li>
                            ))}
                          </ul>

                          <div className="form-check text-center mb-2">
                            <input
                              className="form-check-input float-none me-2"
                              type="radio"
                              name="planSelection"
                              id={`plan_${plan.key}`}
                              checked={isSelected}
                              onChange={() => setSelectedPlanKey(plan.key)}
                            />
                            <label className="form-check-label fw-bold text-dark small" htmlFor={`plan_${plan.key}`}>
                              {isSelected
                                ? (language === "English" ? "Selected Plan" : "निवडलेला प्लॅन")
                                : (language === "English" ? "Select Plan" : "प्लॅन निवडा")}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Summary and Action CTA */}
              {(() => {
                const currentPlan = plans.find((p) => p.key === selectedPlanKey) || plans[0];
                const isCurrentTrial = currentPlan.isTrial === true || currentPlan.key === "freeTrial";

                return (
                  <div className="card shadow-sm border-0 rounded-4 mt-5 bg-white p-4 col-12 col-md-8 mx-auto text-center">
                    <div className="row align-items-center">
                      <div className="col-md-7 text-md-start mb-3 mb-md-0">
                        <h5 className="fw-bold text-dark mb-1">
                          {language === "English" ? "Selected Plan Summary" : "निवडलेल्या प्लॅनचा सारांश"}
                        </h5>
                        <p className="text-primary fw-bold fs-5 mb-0">
                          {language === "English" ? currentPlan.nameEn : currentPlan.nameMr}{" "}
                          - ₹{currentPlan.price.toLocaleString("en-IN")}{" "}
                          / {isCurrentTrial
                            ? (language === "English" ? "7 days" : "७ दिवस")
                            : (language === "English" ? "year" : "वर्ष")}
                          <span className="badge bg-light text-dark border ms-2 fs-7">
                            👥 {currentPlan.studentLimit} {language === "English" ? "Students" : "विद्यार्थी"}
                          </span>
                        </p>
                        <span className="text-muted small">
                          {isCurrentTrial
                            ? (language === "English"
                                ? "Includes 7 days full access for up to 20 students. No payment required."
                                : "कमाल २० विद्यार्थ्यांसाठी ७ दिवसांचा मोफत पूर्ण वापर. कोणतेही शुल्क आवश्यक नाही.")
                            : (language === "English"
                                ? `Includes full 1-year access for up to ${currentPlan.studentLimit} students.`
                                : `कमाल ${currentPlan.studentLimit} विद्यार्थ्यांसाठी १ वर्षाचा पूर्ण ऍक्सेस.`)}
                        </span>
                      </div>
                      <div className="col-md-5 text-md-end">
                        <button
                          className={`btn ${isCurrentTrial ? "btn-primary" : "btn-success"} btn-lg px-4 py-3 fw-bold w-100 shadow`}
                          onClick={handlePaymentAndRegistration}
                          disabled={isProcessingPayment}
                        >
                          {isProcessingPayment ? (
                            <span>
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              {language === "English" ? "Processing..." : "प्रक्रिया सुरू आहे..."}
                            </span>
                          ) : isCurrentTrial ? (
                            <span>
                              🚀 {language === "English" ? "Start 7-Day Free Trial" : "७ दिवसांचा मोफत ट्रायल सुरू करा"}
                            </span>
                          ) : (
                            <span>
                              🔒 {language === "English"
                                ? `Pay ₹${currentPlan.price.toLocaleString("en-IN")} & Activate`
                                : `₹${currentPlan.price.toLocaleString("en-IN")} भरा आणि सुरु करा`}
                            </span>
                          )}
                        </button>
                      </div>
                    </div>

                    <div className="mt-4 border-top pt-3 text-start d-flex justify-content-between align-items-center">
                      <button
                        className="btn btn-link text-decoration-none text-secondary p-0 fw-bold"
                        onClick={() => setStep(1)}
                        disabled={isProcessingPayment}
                      >
                        ← {language === "English" ? "Back to School Details" : "शाळेची माहिती बदला"}
                      </button>
                      <span className="text-muted small">
                        {isCurrentTrial
                          ? "✨ " + (language === "English" ? "Instant Activation without Payment" : "पेमेंट शिवाय त्वरित सक्रियकरण")
                          : "🛡️ " + (language === "English" ? "Secured by Razorpay Payment Gateway" : "रेझरपे द्वारे सुरक्षित पेमेंट")}
                      </span>
                    </div>
                  </div>
                );
              })()}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default SchoolRegister;
